module.exports = __webpack_public_path__ + "static/media/under_maintenance.42fb0e7a.svg";